//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import type { FpBeatModelType } from './FpBeat';
import type { BeatPlanEditsModelType } from './BeatPlanEdits';

export type FpSalesbeatPlanModelType = {
    beatPlanId: string,
    beats: Array<FpBeatModelType>,
    appliedEdits: Array<BeatPlanEditsModelType>,
    netEdits: Array<BeatPlanEditsModelType>,
    createdOn: string,
    planStatus: string,
    unallocatedVisitIds: Array<string>,
    updatedOn: string,
    summary: {
        assignedVisitCount: number,
        beatCount: number,
        outerPolygon: Array<Object>,
        serviceabilityRatio: number,
        totalDuration: number,
        totalTransactionDuration: number,
        totalTravelDistance: number,
        totalTravelDuration: number,
        visitCount: number,
        editsSummary: {
            beatEditCounts: Map<string, Array<BeatEditCountsModelType>>,
            editCount: number,
            editCounts: {
                MOVE: string,
                UNALLOCATION: string
            }
        }
    }
};

export type BeatEditCountsModelType = {
    actor: {
        id: string
    },
    editType: string,
    editedOn: string,
    visitId: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpSalesbeatPlan extends ImmutableModel {
    static fromJS(json: FpSalesbeatPlanModelType): FpSalesbeatPlan {
        const state: Object = Object.assign({}, json);
        state.beats = Immutable.List(state.beats).map(item =>
            FpBeat.fromJS(item)
        );
        state.appliedEdits = Immutable.List(state.appliedEdits).map(item =>
            BeatPlanEdits.fromJS(item)
        );
        state.netEdits = Immutable.List(state.netEdits).map(item =>
            BeatPlanEdits.fromJS(item)
        );
        state.unallocatedVisitIds = Immutable.List(state.unallocatedVisitIds);
        return new this(Immutable.Map(state));
    }

    toJS(): FpSalesbeatPlanModelType {
        return {
            beatPlanId: this.beatPlanId,
            beats: this.beats.toArray().map(item => item.toJS()),
            appliedEdits: this.appliedEdits.toArray().map(item => item.toJS()),
            netEdits: this.netEdits.toArray().map(item => item.toJS()),
            createdOn: this.createdOn,
            planStatus: this.planStatus,
            unallocatedVisitIds: this.unallocatedVisitIds.toArray(),
            updatedOn: this.updatedOn,
            summary: this.summary
        };
    }

    get beatPlanId(): string {
        return this._state.get('beatPlanId');
    }

    setBeatPlanId(beatPlanId: string): this {
        return this.clone(this._state.set('beatPlanId', beatPlanId));
    }

    get beats(): Immutable.List<FpBeat> {
        return this._state.get('beats');
    }

    setBeats(beats: Immutable.List<FpBeat>): this {
        return this.clone(this._state.set('beats', beats));
    }

    get appliedEdits(): Immutable.List<BeatPlanEdits> {
        return this._state.get('appliedEdits');
    }

    setAppliedEdits(appliedEdits: Immutable.List<BeatPlanEdits>): this {
        return this.clone(this._state.set('appliedEdits', appliedEdits));
    }

    get netEdits(): Immutable.List<BeatPlanEdits> {
        return this._state.get('netEdits');
    }

    setNetEdits(netEdits: Immutable.List<BeatPlanEdits>): this {
        return this.clone(this._state.set('netEdits', netEdits));
    }

    get createdOn(): string {
        return this._state.get('createdOn');
    }

    setCreatedOn(createdOn: string): this {
        return this.clone(this._state.set('createdOn', createdOn));
    }

    get planStatus(): string {
        return this._state.get('planStatus');
    }

    setPlanStatus(planStatus: string): this {
        return this.clone(this._state.set('planStatus', planStatus));
    }

    get unallocatedVisitIds(): Immutable.List<string> {
        return this._state.get('unallocatedVisitIds');
    }

    setUnallocatedVisitIds(unallocatedVisitIds: Immutable.List<string>): this {
        return this.clone(
            this._state.set('unallocatedVisitIds', unallocatedVisitIds)
        );
    }

    get updatedOn(): string {
        return this._state.get('updatedOn');
    }

    setUpdatedOn(updatedOn: string): this {
        return this.clone(this._state.set('updatedOn', updatedOn));
    }

    get summary(): {
        assignedVisitCount: number,
        beatCount: number,
        outerPolygon: Array<Object>,
        serviceabilityRatio: number,
        totalDuration: number,
        totalTransactionDuration: number,
        totalTravelDistance: number,
        totalTravelDuration: number,
        visitCount: number,
        editsSummary: {
            beatEditCounts: Map<string, Array<BeatEditCountsModelType>>,
            editCount: number,
            editCounts: {
                MOVE: string,
                UNALLOCATION: string
            }
        }
    } {
        return this._state.get('summary');
    }

    setSummary(summary: {
        assignedVisitCount: number,
        beatCount: number,
        outerPolygon: Array<Object>,
        serviceabilityRatio: number,
        totalDuration: number,
        totalTransactionDuration: number,
        totalTravelDistance: number,
        totalTravelDuration: number,
        visitCount: number,
        editsSummary: {
            beatEditCounts: Map<string, Array<BeatEditCountsModelType>>,
            editCount: number,
            editCounts: {
                MOVE: string,
                UNALLOCATION: string
            }
        }
    }): this {
        return this.clone(this._state.set('summary', summary));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BeatEditCounts extends ImmutableModel {
    static fromJS(json: BeatEditCountsModelType): BeatEditCounts {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): BeatEditCountsModelType {
        return {
            actor: this.actor,
            editType: this.editType,
            editedOn: this.editedOn,
            visitId: this.visitId
        };
    }

    get actor(): { id: string } {
        return this._state.get('actor');
    }

    setActor(actor: { id: string }): this {
        return this.clone(this._state.set('actor', actor));
    }

    get editType(): string {
        return this._state.get('editType');
    }

    setEditType(editType: string): this {
        return this.clone(this._state.set('editType', editType));
    }

    get editedOn(): string {
        return this._state.get('editedOn');
    }

    setEditedOn(editedOn: string): this {
        return this.clone(this._state.set('editedOn', editedOn));
    }

    get visitId(): string {
        return this._state.get('visitId');
    }

    setVisitId(visitId: string): this {
        return this.clone(this._state.set('visitId', visitId));
    }
}
